var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M70.29,36.476H25.71c-1.104,0-2,0.896-2,2v7.25c0,1.104,0.896,2,2,2h0.571v23.633c0,1.104,0.896,2,2,2h39.438 c1.104,0,2-0.896,2-2V47.726h0.571c1.104,0,2-0.896,2-2v-7.25C72.29,37.372,71.395,36.476,70.29,36.476z M27.71,40.476h40.58v3.25 h-0.571H28.281H27.71V40.476z M65.719,69.359H30.281V47.726h35.438V69.359z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.552,35.536h8.896c3.555,0,6.447-2.893,6.447-6.448s-2.893-6.448-6.447-6.448c-1.725,0-3.29,0.685-4.448,1.791 c-1.158-1.107-2.723-1.791-4.448-1.791c-3.556,0-6.448,2.893-6.448,6.448S39.997,35.536,43.552,35.536z M52.448,26.641 c1.35,0,2.447,1.098,2.447,2.448s-1.098,2.448-2.447,2.448c-0.778,0-1.493-0.358-1.961-0.981C50.169,30.129,50,29.623,50,29.088 C50,27.739,51.099,26.641,52.448,26.641z M43.552,26.641c1.35,0,2.448,1.098,2.448,2.448c0,0.855,0.184,1.677,0.502,2.448h-2.95 c-1.35,0-2.448-1.098-2.448-2.448S42.202,26.641,43.552,26.641z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.1ccc2e9bd3e1cfc06eb930b5243fc72b.svg";
export { ForwardRef as ReactComponent };